import { MemoryTableData } from './memoryTableData'

import { PrintFilesColumnId } from '../types/wbFilesColumns'
import { PrintFileGroupModel } from '../server/mpsklad_core/Models/PrintFileGroupModel'

export class LabelStore {
  readonly wbFiles = new MemoryTableData<PrintFileGroupModel, PrintFilesColumnId>('wbFiles')

  readonly ozonFiles = new MemoryTableData<PrintFileGroupModel, PrintFilesColumnId>('ozonFiles')

  readonly yandexMarketFiles = new MemoryTableData<PrintFileGroupModel, PrintFilesColumnId>('yandexMarketFiles')
}
